import { Button, Icon, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaInbox, FaPaperPlane, FaPlus, FaShoppingBasket } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { urls } from "../../../../urls";
import { useLoggedInWithOrgContextState } from "../../../auth/useLoggedInWithOrgContextState";
import { ChooseEventDepartmentModal } from "../../../departments/ChooseEventDepartmentModal";
import { useCreateSourcingEvent } from "../../../departments/useCreateSourcingEvent";
import { useSub } from "../../../subscription/useSub";
import { Explanation } from "../../../support/Explanation/Explanation";

export const Sourcing = () => {
  const navigate = useNavigate();
  const authState = useLoggedInWithOrgContextState();
  const { t } = useTranslation();
  const sub = useSub();
  const createEvent = useCreateSourcingEvent((eventId) => navigate(urls.v2.sourcingEvents.edit.go(eventId).info));
  const canCreateEvent = authState.selectedOrg.canCreateEvent;

  return (
    <>
      {sub.hasBuyerAccess && (
        <>
          <Menu>
            <MenuButton
              as={Button}
              leftIcon={<Icon as={FaShoppingBasket} w="15px" h="15px" />}
              colorScheme="teal"
              variant="ghost"
              size={"sm"}
            >
              {t("Sourcing")}
            </MenuButton>
            <MenuList>
              <Explanation
                enabled={!canCreateEvent}
                placement={"left-start"}
                text={t("Only admins and creators can create new events")}
              >
                <MenuItem
                  isDisabled={!canCreateEvent || createEvent.isCreating}
                  icon={<Icon as={FaPlus} w="15px" h="15px" marginBottom={-0.5} />}
                  onClick={createEvent.start}
                >
                  {t("New event")}
                </MenuItem>
              </Explanation>
              <MenuItem
                icon={<Icon as={FaShoppingBasket} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => {
                  navigate(urls.events.viewAll);
                }}
              >
                {t("All sourcing events")}
              </MenuItem>
            </MenuList>
          </Menu>
          <Menu>
            <MenuList>
              <MenuItem
                icon={<Icon as={FaPaperPlane} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => {
                  navigate(urls.bids.viewAll);
                }}
              >
                {t("Delivered bids")}
              </MenuItem>
              <MenuItem
                icon={<Icon as={FaInbox} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => {
                  navigate(urls.bids.received);
                }}
              >
                {t("Received bids")}
              </MenuItem>
            </MenuList>
          </Menu>
        </>
      )}
      {!sub.hasBuyerAccess && (
        <>
          <Menu>
            <MenuButton
              as={Button}
              leftIcon={<Icon as={FaShoppingBasket} w="15px" h="15px" />}
              colorScheme="teal"
              variant="ghost"
              size={"sm"}
            >
              {t("Bids")}
            </MenuButton>
            <MenuList>
              <MenuItem
                icon={<Icon as={FaInbox} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => navigate(urls.events.viewInvitations)}
              >
                {t("Bid invitations")}
              </MenuItem>
              <MenuItem
                icon={<Icon as={FaPaperPlane} w="15px" h="15px" marginBottom={-0.5} />}
                onClick={() => navigate(urls.bids.viewAll)}
              >
                {t("Delivered bids")}
              </MenuItem>
            </MenuList>
          </Menu>
        </>
      )}
      {createEvent.isChoosingDepartment && (
        <ChooseEventDepartmentModal
          isOpen
          departments={createEvent.departments}
          isCreating={createEvent.isCreating}
          onCancel={createEvent.cancelChoosingDepartment}
          onConfirm={createEvent.confirmDepartment}
        />
      )}
    </>
  );
};
